import { useContext } from 'react'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { LOCATION_SEARCH_TYPE } from '../../types'

export default function useCityNameInFormHeadlineForSEM(
  location?: LOCATION_SEARCH_TYPE
) {
  const { prePopData } = useContext(BootstrapDataContext)
  const endLocation = prePopData?.hotels?.endLocation
  const hasCity = !!endLocation?.cityName && endLocation?.type === 'CITY'
  return hasCity
    ? `Search ${location?.cityName || endLocation?.cityName} Hotels`
    : null
}
